import { Button } from '@/components'
import { Dialog } from '@/components/UI/Dialog'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PointHistoryList } from './PointHistoryList'

export type PointHistoryEntry = {
  id: number | string
  label: string
  point: number
  acquiredAt: string
}

type Props = {
  items: PointHistoryEntry[]
  isOpen: boolean
  onClose: () => void
}

/** ポイント履歴ダイアログ */
export const DialogPointHistory: FC<Props> = ({ items, isOpen, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('point_history.title', 'ポイント履歴')}>
      <div className="mt-3 max-h-[60vh] overflow-y-auto">
        <PointHistoryList items={items} />
        <div className="flex justify-center w-full pt-4 pb-3">
          <Button
            label="OK"
            round
            variant={'system'}
            size="md"
            onClick={onClose}
            className="!w-[254px] [--button-bg:#eeeeee] [--button-color:#757575] [--button-hover:#e0e0e0]"
          />
        </div>
      </div>
    </Dialog>
  )
}
